import DateUtils from "./dateUtils";

const INT_TYPE_NAME = "int";
const FLOAT_TYPE_NAME = "float";
const NUMBER_TYPE_NAME = "number";
const STRING_TYPE_NAME = "string";
const STRDATETIME_TYPE_NAME = "dateTime";
const OBJECT_TYPE_NAME = "object";
const ARRAYOF_INT_TYPE_NAME = "arrayOfInt";
const ARRAYOF_FLOAT_TYPE_NAME = "arrayOfFloat";
const ARRAYOF_NUMBER_TYPE_NAME = "arrayOfNumber";
const ARRAYOF_STRING_TYPE_NAME = "arrayOfString";
const ARRAYOF_STRDATETIME_TYPE_NAME = "arrayOfStrDateTime";
const ARRAYOF_OBJECT_TYPE_NAME = "arrayOfObject";

const Types = {
    INT: INT_TYPE_NAME,
    FLOAT: FLOAT_TYPE_NAME,
    NUMBER: NUMBER_TYPE_NAME,
    STRING: STRING_TYPE_NAME,
    STRDATETIME: STRDATETIME_TYPE_NAME,
    OBJECT: OBJECT_TYPE_NAME,
    ARRAYOF_INT: ARRAYOF_INT_TYPE_NAME,
    ARRAYOF_FLOAT: ARRAYOF_FLOAT_TYPE_NAME,
    ARRAYOF_NUMBER: ARRAYOF_NUMBER_TYPE_NAME,
    ARRAYOF_STRING: ARRAYOF_STRING_TYPE_NAME,
    ARRAYOF_STRDATETIME: ARRAYOF_STRDATETIME_TYPE_NAME,
    ARRAYOF_OBJECT: ARRAYOF_OBJECT_TYPE_NAME,
    ARRAY_TYPES: [
        ARRAYOF_INT_TYPE_NAME,
        ARRAYOF_FLOAT_TYPE_NAME,
        ARRAYOF_NUMBER_TYPE_NAME,
        ARRAYOF_STRING_TYPE_NAME,
        ARRAYOF_STRDATETIME_TYPE_NAME,
        ARRAYOF_OBJECT_TYPE_NAME,
    ],
};
Types.ARRAY_TYPE_ELEM_TYPES_MAP = {};
Types.ARRAY_TYPE_ELEM_TYPES_MAP[ARRAYOF_INT_TYPE_NAME] = INT_TYPE_NAME;
Types.ARRAY_TYPE_ELEM_TYPES_MAP[ARRAYOF_FLOAT_TYPE_NAME] = FLOAT_TYPE_NAME;
Types.ARRAY_TYPE_ELEM_TYPES_MAP[ARRAYOF_NUMBER_TYPE_NAME] = NUMBER_TYPE_NAME;
Types.ARRAY_TYPE_ELEM_TYPES_MAP[ARRAYOF_STRING_TYPE_NAME] = STRING_TYPE_NAME;
Types.ARRAY_TYPE_ELEM_TYPES_MAP[
    ARRAYOF_STRDATETIME_TYPE_NAME
] = STRDATETIME_TYPE_NAME;
Types.ARRAY_TYPE_ELEM_TYPES_MAP[ARRAYOF_OBJECT_TYPE_NAME] = OBJECT_TYPE_NAME;

class TypeSpec {
    constructor(type, maxStrLen, nullable) {
        this.type = type;
        this.maxStrLen = maxStrLen;
        this.nullable = nullable;
    }
}

class TypesUtils {
    static isStr(v) {
        return typeof v === STRING_TYPE_NAME;
    }

    static isArray(v) {
        return Array.isArray(v);
    }

    static isOfType(Type, v) {
        return v.constructor === Type;
    }

    static undefOrNull(v) {
        return v == null;
    }

    static notUndefOrNull(v) {
        return v != null;
    }

    static getValueOrDefault(value, defaultValue) {
        return this.notUndefOrNull(value) ? value : defaultValue;
    }

    static isNumber(n) {
        return !this.isStr(n) && !isNaN(n) && isFinite(n);
    }

    static isNumberOrStrNum(n) {
        if (this.undefOrNull(n)) return false;
        let val = n;
        if (this.isStr(n)) val = parseInt(n, 10);
        return !this.isStr(val) && !isNaN(val) && isFinite(val);
    }

    static isIntOrStrInt(str) {
        /*if (this.undefOrNull(str)) return false;
    let val = str;
    if (this.isStr(str)) val = parseInt(str,10);
    return !this.isStr(val) && !isNaN(val) && isFinite(val);
*/
        if (Number.isInteger(str)) return true;
        str = str.trim();
        if (!str) {
            return false;
        }
        str = str.replace(/^0+/, "") || "0";
        let n = Math.floor(Number(str));
        return n !== Infinity && String(n) === str && n >= 0;
    }

    static isNumberGTZero(n) {
        return this.isNumber(n) && n > 0;
    }

    static isNumberOrStrNumGTZero(n) {
        return this.isNumberOrStrNum(n) && n > 0;
    }

    /**
     * Retorna true si v es un objeto, false si no lo es o si es null
     * @param {*} v
     */
    static isObject(v) {
        return typeof v === "object" && v !== null;
    }

    static validateType(val, type) {
        if (this.undefOrNull(type))
            throw new Error(
                "validateType: Error param `type` can not be `undefined`"
            );
        return (
            (this.notUndefOrNull(val) &&
                type === Types.INT &&
                this.isIntOrStrInt(val)) ||
            (type === Types.FLOAT && this.isNumberOrStrNum(val)) ||
            (type === Types.STRING && this.isStr(val)) ||
            (type === Types.NUMBER && this.isNumberOrStrNum(val)) ||
            (type === Types.OBJECT && this.isObject(val)) ||
            TypesUtils.validateArrayType(val, type)
        );
    }

    static validateArrayType(v, typeSpec) {
        if (!this.isArrayType(typeSpec.type)) return false;
        if (!Array.isArray(v)) v = [v];
        return !v.some(
            (item) =>
                !TypesUtils.validateType(
                    item,
                    Types.ARRAY_TYPE_ELEM_TYPES_MAP[typeSpec.type]
                )
        );
    }

    static isArrayType(type) {
        return Types.ARRAY_TYPES.includes(type);
    }

    static validateTypeEx(val, typeSpec) {
        if (this.undefOrNull(typeSpec))
            throw new Error(
                "validateType: Error param `type` can not be `undefined`"
            );
        if (TypesUtils.undefOrNull(val) && typeSpec.nullable !== true)
            return false;
        else if (TypesUtils.undefOrNull(val) && typeSpec.nullable === true)
            return true;

        return (
            (typeSpec.type === Types.INT && TypesUtils.isIntOrStrInt(val)) ||
            (typeSpec.type === Types.FLOAT &&
                TypesUtils.isNumberOrStrNum(val)) ||
            (typeSpec.type === Types.STRING &&
                TypesUtils.isStr(val) &&
                (TypesUtils.undefOrNull(typeSpec.maxStrLen) ||
                    val.length < typeSpec.maxStrLen)) ||
            (typeSpec.type === Types.NUMBER &&
                TypesUtils.isNumberOrStrNum(val)) ||
            (typeSpec.type === Types.OBJECT && TypesUtils.isObject(val)) ||
            (typeSpec.type === Types.STRDATETIME &&
                TypesUtils.isStr(val) &&
                DateUtils.validateStrDate(val) !== null) ||
            TypesUtils.validateArrayType(val, typeSpec)
        );
    }

    static validateArrayTypeEx(v, typeSpec) {
        if (!Types.ARRAY_TYPES.includes(typeSpec.type)) return false;
        return (
            Array.isArray(v) &&
            !v.some((item) => {
                let typeSpecItem = new TypeSpec(
                    Types.ARRAY_TYPE_ELEM_TYPES_MAP[typeSpec.type],
                    typeSpec.maxStrLen,
                    typeSpec.nullable
                );
                return !TypesUtils.validateTypeEx(item, typeSpecItem);
            })
        );
    }

    static strToBool(s) {
        if (s === "true" || s === true) return true;
        return false;
    }
}

export { TypesUtils as default, Types, TypeSpec };
